export function get (message)
{
	return message.disclosedData?.nameWithSalutation || message.pseudonym.label;
}
